// extracted by mini-css-extract-plugin
export default {"root":"ChallengeLabStatusIcon_root__9Q4PS"};